import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { BookOpen } from "lucide-react";

const ROLES = [
  { key: "admin", label: "Yönetici" },
  { key: "user", label: "Personel" },
  { key: "izleyici", label: "Patron (İzleyici)" },
  { key: "katip", label: "Katip" },
  { key: "avukat", label: "Avukat" },
];

export default function KilavuzButton() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const isAdmin = user?.role === "admin";
  const base = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const download = (role) => {
    const url = role ? `${base}/api/kilavuz?role=${role}` : `${base}/api/kilavuz`;
    window.open(url, "_blank");
    setOpen(false);
  };

  if (!user) return null;

  if (!isAdmin) {
    return (
      <button
        onClick={() => download()}
        data-testid="kilavuz-button"
        aria-label="Kullanım Kılavuzu"
        title="Kullanım Kılavuzu (PDF)"
        className="flex items-center gap-1.5 px-2 sm:px-3 py-2 text-sm text-[#8C8377] hover:text-[#B8933F] hover:bg-[#EFE7D6] rounded-sm transition-colors duration-150"
      >
        <BookOpen className="w-4 h-4" /> <span className="hidden sm:inline">Kılavuz</span>
      </button>
    );
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="kilavuz-button"
        aria-label="Kullanım Kılavuzu"
        title="Kullanım Kılavuzu (PDF)"
        className="flex items-center gap-1.5 px-2 sm:px-3 py-2 text-sm text-[#8C8377] hover:text-[#B8933F] hover:bg-[#EFE7D6] rounded-sm transition-colors duration-150"
      >
        <BookOpen className="w-4 h-4" /> <span className="hidden sm:inline">Kılavuz</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white border border-[#E7DECC] rounded-lg shadow-xl z-[70] overflow-hidden" data-testid="kilavuz-menu">
          <div className="px-3 py-2 bg-[#F3ECDD] kicker border-b border-[#E7DECC]">Rol Kılavuzu İndir</div>
          {ROLES.map((r) => (
            <button
              key={r.key}
              onClick={() => download(r.key)}
              data-testid={`kilavuz-role-${r.key}`}
              className="w-full flex items-center gap-2 px-3 py-2.5 text-sm text-left hover:bg-[#EFE7D6] border-b border-[#F0E9DA] last:border-b-0 transition-colors duration-150"
            >
              <BookOpen className="w-4 h-4 text-[#B8933F]" /> {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
